<template>
  <div class="app-main-content railwayStation">
    <div class="grid-view">
      <div class="main-content">
        <div class="operations">
          <el-form
            :inline="true"
            label-width="50px"
            label-position="left"
            @submit.native.prevent="filter.pageNum=1;toQuery()"
          >
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('common.btn.query')">
                <el-input
                  v-model="filter.likeName"
                  :no="'searchInput'"
                  :placeholder="$t('common.tips.fuzzySearch')"
                  style="width:310px"
                />
              </el-form-item>
              <el-button :no="'query'" size="mini" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
              <el-button v-show="tenantId !== PLATFORM_TENANT_ID" :no="'addOverseaWarehouse'" size="mini" type="primary" @click="addOverseaWarehouseHandler">{{ $t('baseInfo.overseaWarehouse.btn.newFbaWarehouse') }}</el-button>
              <el-button v-if="tenantId === PLATFORM_TENANT_ID" :no="'newFbaWarehouse'" size="mini" type="primary" @click="newOverseaWarehouseHandler">{{ $t('common.btn.new') }}</el-button>
              <el-button v-else :no="'newOverseaWarehouse'" size="mini" type="primary" @click="newOverseaWarehouseHandler">{{ $t('baseInfo.overseaWarehouse.btn.newOverseaWarehouse') }}</el-button>
              <el-button :no="'edit'" size="mini" type="primary" @click="editHandler">{{ $t('common.btn.edit') }}</el-button>
              <el-button :no="'delete'" size="mini" type="danger" @click="toDelete">{{ $t('common.btn.delete') }}</el-button>
            </div>
          </el-form>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="girdParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="total>0"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <oversea-warehouse-edit-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      :tenant-id="tenantId"
      :oversea-warehouse="editDialog.overseaWarehouse"
      @saveCallBack="editDialog.saveCallBack"
      @close="editDialog.visible=false"
    />
    <!-- 新增弹窗（非平台维护） -->
    <select-oversea-warehouse-template-list-dialog
      :visible.sync="fbaWarehouseListDialog.visible"
      :tenant-id="tenantId"
      @addCallBack="fbaWarehouseListDialog.addCallBack"
      @close="fbaWarehouseListDialog.visible=false"
    />
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import baseCity from './components/baseCity'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getUserInfo } from '@/utils/auth'
import { getLoading } from '@/utils/utilBaseElement'
import { exportExcel, exportPdf } from '@/utils/tableDataExportUtils'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import SelectOverseaWarehouseTemplateListDialog from '@/views/cargo/v0/Information/components/SelectOverseaWarehouseTemplateListDialog'
import OverseaWarehouseEditDialog from '@/views/cargo/v0/Information/components/OverseaWarehouseEditDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import { batchDelete, getOverseaWarehouseList, getUsedOverseaWarehouse } from '@/api/basicData/overseaWarehouse'
import $store from '@/store'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'OverseaWarehouse',
  components: {
    OverseaWarehouseEditDialog,
    SelectOverseaWarehouseTemplateListDialog,
    cargoAdvanceSelect,
    baseCity
  },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        tenantId: 0,
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        getContextMenuItems: () => {
          return [
            {
              name: this.$t('CargoMsg.Cargo_ExcelExport'),
              action: function() {
                this.exportExcelHandler()
              }
            },
            {
              name: this.$t('CargoMsg.Cargo_DataExportPDF'),
              action: function() {
                this.exportPdfHandler()
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.warehouseCode'),
          field: 'warehouseCode',
          width: 100
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.countryChineseName'),
          field: 'countryChineseName',
          width: 100
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.countryEnglishName'),
          field: 'countryEnglishName',
          width: 100
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.country'),
          field: 'countryCode',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, 'name')
          }
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.province'),
          field: 'province',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.city'),
          field: 'cityName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.zipCode'),
          field: 'zipCode',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.address'),
          field: 'address1',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.ifFba'),
          field: 'ifFba',
          width: 200,
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.entryRequirements'),
          field: 'entryRequirements',
          width: 200
        }, {
          headerName: this.$t('baseInfo.overseaWarehouse.warehouseAgeCalculationRules'),
          field: 'warehouseAgeCalculationRules',
          width: 200,
          cellRenderer: params => {
            const targetField = $store.getters.language === 'zh' ? 'chineseName' : 'englishName'
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.local_cache_FbaJobConstants$WAREHOUSE_AGE_CALCULATION_RULES, 'code', params.value, targetField)
          }
        }
      ],
      rowData: [],
      tenantId: 0,
      editDialog: {
        visible: false,
        title: '',
        overseaWarehouse: null,
        saveCallBack: () => {
        }
      },
      fbaWarehouseListDialog: {
        visible: false,
        addCallBack: () => {
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    this.toQuery()
  },
  methods: {
    toQuery() {
      const loading = getLoading()
      this.filter.tenantId = this.tenantId
      const params = { ...this.filter }
      getOverseaWarehouseList(params).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showAddDialog() {
      if (this.tenantId === this.PLATFORM_TENANT_ID) {
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewOverseaWarehouse')
        this.editDialog.visible = true
        this.editDialog.overseaWarehouse = null
        this.editDialog.saveCallBack = this.addCallBackHandler
      } else {
        this.fbaWarehouseListDialog.visible = true
        this.fbaWarehouseListDialog.addCallBack = this.addCallBackHandler
      }
    },
    newOverseaWarehouseHandler() {
      this.editDialog.title = this.$t('CargoMsg.Cargo_NewOverseaWarehouse')
      this.editDialog.visible = true
      this.editDialog.overseaWarehouse = null
      this.editDialog.saveCallBack = this.addCallBackHandler
    },
    addOverseaWarehouseHandler() {
      this.fbaWarehouseListDialog.visible = true
      this.fbaWarehouseListDialog.addCallBack = this.addCallBackHandler
    },
    editHandler() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.rowData[cell.rowIndex] : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.editDialog.overseaWarehouse = row
      this.editDialog.title = this.$t('CargoMsg.Cargo_ModifyOverseaWarehouse')
      this.editDialog.visible = true
      this.editDialog.saveCallBack = this.addCallBackHandler
    },
    async toDelete() {
      const selectedList = getGridSelected(this.gridOptions)
      const warehouseCode = []
      selectedList.forEach(e => warehouseCode.push(e.warehouseCode))
      const data = { warehouseCodeList: warehouseCode, tenantId: this.tenantId }
      let usedFlag = false
      await getUsedOverseaWarehouse(data).then(res => {
        const data = res.data
        if (data && data.length > 0) {
          usedFlag = true
          this.$message.warning(StrUtils.substitute(this.$t('CargoMsg.Cargo_CannotDeleteWarehouse'), data[0]))
        }
      })
      if (usedFlag) {
        return
      }
      getGridSelectedIds(this.gridOptions, 'uuid').then(uuidList => {
        return this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          const chooseRows = getGridSelected(this.gridOptions)
          const warehouseCodeList = chooseRows.map(item => {
            return item.warehouseCode
          })
          const data = { uuidList: uuidList, warehouseCodeList: warehouseCodeList, tenantId: this.tenantId }
          return batchDelete(data)
        }).catch(() => {
          return Promise.reject(this.$t('Message.DeletionCancelled'))
        })
      }).then(res => {
        if (res.ok) {
          syncSpecificBasicData(basicCacheKeys.basic_data_OverseaWarehouse)
          this.toQuery()
          this.$message({
            type: 'success',
            message: this.$t('Message.DeleteSucceeded')
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('Message.DeleteFail')
          })
        }
      })
    },
    addCallBackHandler() {
      this.toQuery()
    },
    exportExcelHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('Information.OverseasWarehouse'), this.rowData, columnDefs)
    },
    exportPdfHandler() {
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportPdf(this.$t('Information.OverseasWarehouse'), this.rowData, columnDefs)
    }
  }
}
</script>

<style lang="scss">
#app {
  .city .app-main-page {
    height: calc(100vh - 100px);
  }

  .hasTagsView {
    .city .app-main-page {
      height: calc(100vh - 130px);
    }
  }
}
</style>
